import React from 'react';
import './WhatWeDoBest.css';

import doctorTeam from './assets/doctors-patient.png';
import stethoscopeImg from './assets/dental-intrument-new-back.png';

const WhatWeDoBest = () => {
  return (
    <div className="wwdb-wrapper">
      {/* HERO SECTION */}
      <section className="wwdb-hero">
        <div className="wwdb-hero-bg">
          <div className="wwdb-hero-content">
            <h1 className="wwdb-main-title">OUR COMMITMENT</h1>
            <p className="wwdb-subtitle">TRANSPARENCY & TRUST</p>

            <div className="wwdb-services">
              <div className="wwdb-service-item">
                <div className="wwdb-diamond-icon">
                  <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" /></svg>
                </div>
                <div className="wwdb-service-text">
                  <h3>YOUR PRIVACY IS OUR PRIORITY</h3>
                  <p>We never share or sell your personal information to third parties.</p>
                </div>
              </div>

              <div className="wwdb-service-item">
                <div className="wwdb-diamond-icon">
                  <svg viewBox="0 0 24 24"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" /></svg>
                </div>
                <div className="wwdb-service-text">
                  <h3>DATA PROTECTION STANDARDS</h3>
                  <p>We adhere to strict confidentiality guidelines and security measures.</p>
                </div>
              </div>

              <div className="wwdb-service-item">
                <div className="wwdb-diamond-icon">
                  <svg viewBox="0 0 24 24"><path d="M19.14 12.94c0.04-0.3 0.06-0.61 0.06-0.94s-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14 0.23-0.41 0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39 0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4 2.81c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24 0-0.43 0.17-0.47 0.41L9.25 5.35C8.66 5.59 8.12 5.92 7.63 6.29L5.24 5.33c-0.22-0.08-0.47 0-0.59 0.22L2.74 8.87C2.62 9.08 2.66 9.34 2.86 9.48l2.03 1.58C4.84 11.36 4.8 11.69 4.8 12s0.02 0.64 0.07 0.94l-2.03 1.58c-0.18 0.14-0.23 0.41-0.12 0.61l1.92 3.32c0.12 0.22 0.37 0.29 0.59 0.22l2.39-0.96c0.5 0.38 1.03 0.7 1.62 0.94l0.36 2.54c0.05 0.24 0.24 0.41 0.48 0.41h3.84c0.24 0 0.44-0.17 0.47-0.41l0.36-2.54c0.59-0.24 1.13-0.56 1.62-0.94l2.39 0.96c0.22 0.08 0.47 0 0.59-0.22l1.92-3.32c0.12-0.22 0.07-0.47-0.12-0.61L19.14 12.94zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" /></svg>
                </div>
                <div className="wwdb-service-text">
                  <h3>NO DATA COLLECTION POLICY</h3>
                  <p>We operate without tracking cookies or analytics that compromise privacy.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="wwdb-doctor-image">
            <img src={doctorTeam} alt="Professional Team" />
          </div>
        </div>
      </section>

      {/* BOTTOM SECTION */}
      <section className="wwdb-bottom-section">
        <div className="wwdb-bottom-container">
          <div className="wwdb-card patient-facilities">
            <div className="wwdb-card-header red">FREQUENTLY ASKED QUESTIONS</div>
            <div className="wwdb-card-body">

              {/* FAQ Item 1 */}
              <div className="wwdb-radio-faq">
                <input type="radio" name="faq" id="faq1" className="wwdb-faq-input" />
                <label htmlFor="faq1" className="wwdb-faq-label">
                  <span className="dot"></span>
                  <strong>DO YOU COLLECT MY PERSONAL DATA?</strong>
                  
                </label>
                <div className="wwdb-faq-content">
                  <p>No, we do not collect any personal data. Our website operates without tracking cookies, analytics, or data collection forms.</p>
                </div>
              </div>

              {/* FAQ Item 2 */}
              <div className="wwdb-radio-faq">
                <input type="radio" name="faq" id="faq2" className="wwdb-faq-input" />
                <label htmlFor="faq2" className="wwdb-faq-label">
                  <span className="dot"></span>
                  <strong>HOW DO YOU PROTECT PRIVACY?</strong>
                  
                </label>
                <div className="wwdb-faq-content">
                  <p>We follow strict privacy protocols, use no third-party trackers, and ensure all communications remain confidential.</p>
                </div>
              </div>

              {/* FAQ Item 3 */}
              <div className="wwdb-radio-faq">
                <input type="radio" name="faq" id="faq3" className="wwdb-faq-input" />
                <label htmlFor="faq3" className="wwdb-faq-label">
                  <span className="dot"></span>
                  <strong>DO YOU USE COOKIES?</strong>
                  
                </label>
                <div className="wwdb-faq-content">
                  <p>We use only essential cookies required for basic site functionality. No tracking or analytics cookies are used.</p>
                </div>
              </div>

            </div>
          </div>

          <div className="wwdb-card skills-card">
            <div className="wwdb-card-header blue">PRIVACY COMMITMENT</div>
            <div className="wwdb-card-body">
              <div className="wwdb-skill">
                <span>No Data Collection</span>
                <div className="progress-bar"><div className="fill" style={{ width: '100%' }}></div></div>
                <span className="percent">100%</span>
              </div>
              <div className="wwdb-skill">
                <span>No Third-Party Tracking</span>
                <div className="progress-bar"><div className="fill" style={{ width: '100%' }}></div></div>
                <span className="percent">100%</span>
              </div>
              <div className="wwdb-skill">
                <span>Cookie-Free Experience</span>
                <div className="progress-bar"><div className="fill" style={{ width: '100%' }}></div></div>
                <span className="percent">100%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="wwdb-stethoscope">
          <img src={stethoscopeImg} alt="Professional Equipment" />
        </div>
      </section>
    </div>
  );
};

export default WhatWeDoBest;